export function gaFaqToggle (faq, action) {
  if (window.dataLayer) {
    window.dataLayer.push({
      'event': 'faqToggle',
      'faqAction': action,
      'faqQuestion': faq.question,
      'faqKey': faq.key
    });
  }
}
